/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { IPartnerAgreementState } from './model'
import { IRootState } from '@/store/model'

const state: IPartnerAgreementState = {
  partnerId: null,
  agreementId: null
}

const mutations: MutationTree<IPartnerAgreementState> = {
  SET_PARTNER_ID: (state, data) => {
    state.partnerId = data
  },
  SET_AGREEMENT_ID: (state, data) => {
    state.agreementId = data
  },
  FLUSH_PARTNER_AGREEMENT: (state, data) => {
    state.partnerId = null
    state.agreementId = null
  }
}

const actions: ActionTree<IPartnerAgreementState, IRootState> = {
  setPartnerId: ({ commit }, data: any) => {
    commit('SET_PARTNER_ID', data)
  },
  setAgreementId: ({ commit }, data: any) => {
    commit('SET_AGREEMENT_ID', data)
  },
  flushPartnerAgreement: ({ commit }) => {
    commit('FLUSH_PARTNER_AGREEMENT')
  }
}

const getters: GetterTree<IPartnerAgreementState, IRootState> = {
  getPartnerId: (state) => state.partnerId,
  getAgreementId: (state) => state.agreementId
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}